export const all_routes = {
  login: "/login",
  register: "/register",
  dashboard: "/dashboard",
  verifyOtp: "/verify-otp",
  PatientFamilyMember: "/patient-family-member",
  Appointment: "/appointment",
  appointmentList:"/appointmentList",

};
